import { render, staticRenderFns } from "./ListOfCompaniesTableItem.vue?vue&type=template&id=43234318&"
import script from "./ListOfCompaniesTableItem.vue?vue&type=script&lang=ts&"
export * from "./ListOfCompaniesTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports